import React, { Fragment, useState, useEffect, useCallback } from "react";
import Avatar from "react-avatar";
import { Row, Col, Label, Card, Container } from "reactstrap";
import { H3, H5 } from "../../../../AbstractElements";
import { getCustomerByIdAPI } from "../../../../Library/apis";
import MothriftLoader from '../../Common/MothriftLoader';
import { toast } from 'react-toastify';

function CustomerProfileSetting({ userId }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const getUser = useCallback(() => {
    if (!userId) return;

    setLoading(true);
    getCustomerByIdAPI(userId)
      .then((res) => {
        const userData = res.data?.data || res.data; 
        setUser(userData);
      })
      .catch((err) => {
        toast.error("Fetch Error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [userId]);

  useEffect(() => {
    getUser();
  }, [getUser]);

  if (loading) return <MothriftLoader />; // Used MothriftLoader here
  if (!user) return <div className="p-4 text-center">No user data found.</div>;

  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col xxl={4} xl={6} xs={12}>
            <Card className="p-4 border-0 shadow-sm">
              <Row className="mb-4">
                <div className="profile-title">
                  <div className="media d-flex align-items-center" style={{ gap: "20px" }}>
                    <Avatar
                      name={user.userName || user.firstName}
                      size="100"
                      round={true}
                      src={user.profileImageUrl}
                    />
                    <div className="media-body">
                      <H3 attrH3={{ className: "mb-1 text-dark" }}>
                        {user.userName || `${user.firstName} ${user.lastName}`}
                      </H3>
                      <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                        ID: {user.userId || userId}
                      </p>
                    </div>
                  </div>
                </div>
              </Row>

              <Row className="gy-3">
                <Col sm="12">
                  <Label className="form-label text-muted mb-1">Email Address</Label>
                  <H5 className="mb-0">{user.email || "No email provided"}</H5>
                </Col>
                <Col sm="12">
                  <Label className="form-label text-muted mb-1">Phone Number</Label>
                  <H5 className="mb-0">{user.phoneNumber || "No phone number"}</H5>
                </Col>
                {user.bankVerificationNumber && (
                   <Col sm="12">
                   <Label className="form-label text-muted mb-1">BVN</Label>
                   <H5 className="mb-0">{user.bankVerificationNumber}</H5>
                 </Col>
                )}
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default CustomerProfileSetting;